import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { formatDateTime } from '../../libs';
import { withStyles } from '@material-ui/core/styles';
import { BASE_URL } from 'constants/Url';

const styles = ({
    notify: {
        height: "100%"
    }

})

class NotificationItem extends React.Component {

  clickNotify(notifi_id, link,is_read, e ) {
    e.preventDefault()
;   this.props.clickNotify(notifi_id, link, is_read)
  }
    render() {
        let { notification, classes } = this.props;
        let { title, time, data } = notification;
        data = JSON.parse(data);
        return (
            <li onClick={ this.clickNotify.bind(this,notification.id || 0, data.link, notification.is_read)} className="media">
                <Avatar
                    alt={
                        data.image ||
                        `${BASE_URL}/static/logo_new.png`
                    }
                    src={
                        data.image ||
                        `${BASE_URL}/static/logo_new.png`
                    }
                    className="mr-2"
                    variant="square"
                    classes={{
                        root: classes.notify
                    }}
                />
                <div className="media-body align-self-center">
                    {notification.is_read ? (
                        <p className="sub-heading mb-0">{title}</p>
                    ) : (
                        <p><b className="sub-heading mb-0">{title}</b></p>
                    )}
                    <span className="meta-date">
                        <small>{formatDateTime(time)}</small>
                    </span>
                </div>
            </li>
        );
    }
}

export default withStyles(styles)(NotificationItem);
